import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Link, Redirect } from 'react-router-dom';
import { convertDate } from '../../utils/utils';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as assessmentsActions from '../../redux/actions/assessmentsActions';
import * as sectionsActions from '../../redux/actions/sectionsActions';

import SectionCheckboxIcon from '../icons/SectionCheckboxIcon';
import LoadingButton from '../common/LoadingButton';

class CompleteAssessmentPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isRequestingPDF: false
    }
  }

  componentDidMount() {
    // TO DO: change to just this assessment
    this.props.assessmentsActions.getAssessments();
    if (!this.props.status.sections) {
      this.props.sectionsActions.getSections();
    }
  }

  download = () => {
    const thisAssessmentId = this.props.match.params.assessmentId
      ? this.props.match.params.assessmentId
      : this.props.currentAssessment.id;
    this.props.assessmentsActions.downloadComparison([thisAssessmentId], this.onSuccess);
    this.setState({
      isRequestingPDF: true
    })
  }

  onSuccess = () => {
    this.setState({
      isRequestingPDF: false
    })
  }

  render() {
    // TO DO: This render() is styled with a mix of other components. Abstract those classes.
    // 1. wait if we need assessments or sections data from the server
    if (!Object.keys(this.props.assessments).length || !this.props.status.sections) return null;
    const thisAssessment = this.props.match.params.assessmentId
      ? this.props.assessments[this.props.match.params.assessmentId]
      : this.props.assessments[this.props.currentAssessment.id];
    // 2. catch if the URL doesn't make sense
    if (!thisAssessment) return <Redirect to="/" />;
    const thisSection = this.props.sections[thisAssessment.section];
    // 3. otherwise we have a real assessment and the data to render it
    return (
      <div className="complete-assessment row">
        <Helmet>
          <title>Assessment complete</title>
        </Helmet>
        <h1 className="complete-assessment__heading">
          Assessment complete
        </h1>
        <div className="complete-assessment__text">
          <p>
            Nice work!
          </p>
          <p>
            This assessment module is complete and has been saved.{' '}
            <span className="hide-on-mobile"><br /></span>
             You can view this any time from the assessments page and compare  with any other assessment modules that have been completed.
          </p>
        </div>
        <div className="assessments-list">
          <div className="assessments-list__card">
            <div className="assessments-list__checkbox assessments-list__col-1">
              <SectionCheckboxIcon theme={thisSection.theme} />
            </div>
            <div className={"assessments-list__section assessments-list__col-2 color--" + thisSection.theme}>
              {thisSection.fullTitle}
            </div>
            <div className="assessments-list__date assessments-list__col-3">
              Completed: {convertDate(thisAssessment.dateCompleted)}
            </div>
            <div className="assessments-list__name assessments-list__col-4">
              {this.props.users[thisAssessment.lastEditedBy] &&
                this.props.users[thisAssessment.lastEditedBy].firstName + ' ' + this.props.users[thisAssessment.lastEditedBy].lastName
              }
            </div>
          </div>
        </div>
        <div className="dashboard-content__sidebar">
          <Link to="/assessments" className="button button--full-width button--large dashboard-content__button dashboard-content__button--no-text">
            Compare Assessments
          </Link>
          <LoadingButton
            text="Download"
            onClick={this.download}
            loading={this.state.isRequestingPDF}
            largeButton={true}
            extraClasses="button--full-width dashboard-content__button dashboard-content__button--no-text"
          />
          <Link to="/assessments/new" className="button button--full-width button--large dashboard-content__button dashboard-content__button--no-text">
            New Assessment
          </Link>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    assessments: state.assessments.list,
    currentAssessment: state.assessments.currentAssessment,
    sections: state.sections,
    status: state.status,
    users: state.users.roster
  };
}

function mapDispatchToProps(dispatch) {
  return {
    assessmentsActions: bindActionCreators(assessmentsActions, dispatch),
    sectionsActions: bindActionCreators(sectionsActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompleteAssessmentPage);


// WEBPACK FOOTER //
// ./src/components/pages/CompleteAssessmentPage.js